import React from "react";
import IconGrid from "../common/IconGrid";
import { TECH_STACK } from "../../data/techStack";

function Techstack() {
  return <IconGrid items={TECH_STACK} />;
}

export default Techstack;
